<template>
    <v-container fluid>
        <template v-if="isAuthorized">
            <v-row no-gutters>
                <v-col cols="2">
                    <v-select
                        v-model="operatingAccountId"
                        :items="tableTypes"
                        item-value="id"
                        label="Table"
                        hide-details
                        density="compact"
                        :item-title="(item) => item.name"
                    >
                    </v-select>
                </v-col>
                <v-col cols="2" class="pl-2">
                    <v-select
                        v-model="partitionTagId"
                        :items="partitionTags"
                        item-value="id"
                        label="Partition"
                        hide-details
                        density="compact"
                        :item-title="(item) => item.name"
                    >
                    </v-select>
                </v-col>
                <v-col cols="2" v-for="(tag, index) in selectedPath" :key="index" class="pl-2">
                    <v-select
                        v-model="tag.selected"
                        :items="tag.tags"
                        label="Etiquette"
                        density="compact"
                        hide-details
                        return-object
                        :item-title="(item) => item.name"
                        multiple
                    />
                </v-col>
            </v-row>
            <v-row no-gutters class="d-flex justify-center" v-for="(table, ti) in tables" :key="ti">
                <v-col cols="12">
                    <div class="d-flex justify-start align-center">
                        <h1 class="pt-2 pb-2">{{ table.name || "Comptes comptables" }}</h1>
                        <v-btn-icon icon="$oss-download" @click.stop="download(table)">
                        </v-btn-icon>
                        <v-btn-icon icon="$oss-duplicate" @click.stop="copy(table)"> </v-btn-icon>
                    </div>
                    <div class="tableStyle">
                        <oss-data-table
                            :items="table.rows"
                            :headers="[]"
                            :fixed-header="true"
                            hide-default-footer
                            :items-per-page="-1"
                            :x-dense="true"
                            v-if="!operatingAccountId"
                        >
                            <template #header>
                                <!-- <thead> -->
                                <tr v-for="(tHeader, hi) in table.headers" :key="hi">
                                    <th
                                        v-for="(column, ci) in tHeader"
                                        :key="hi + '_' + ci"
                                        :colspan="column.colspan || ''"
                                        :style="getHeaderStyle(hi, column, ci)"
                                        :class="getHeaderClass(hi, column, ci)"
                                    >
                                        {{ column.text }}
                                    </th>
                                </tr>
                                <!-- </thead> -->
                            </template>
                            <template #item="{ item }">
                                <tr
                                    class="text-left"
                                    v-if="item.title && !item.total"
                                    :style="itemRowBackground(item)"
                                >
                                    <td
                                        colspan="1"
                                        class="vertical-sticky"
                                        :style="verticalSepratorStyle"
                                    >
                                        <strong>{{ item.title }}</strong>
                                    </td>
                                    <td :colspan="getColumnCount(table) - 1" />
                                </tr>
                                <tr
                                    v-else
                                    :style="itemRowBackground(item)"
                                    @click.stop="openAABDetailDialog(item.aaName)"
                                >
                                    <td
                                        class="text-left vertical-sticky"
                                        :style="colorElement2(item)"
                                    >
                                        {{ getRowTitle(item) }}
                                    </td>
                                    <template v-for="(period, pi) in resultPeriods">
                                        <td
                                            class="text-right"
                                            :style="
                                                addVerticalSeparatorStyle(table, ci, pi)
                                                    ? verticalSepratorStyle
                                                    : ''
                                            "
                                            v-for="(col, ci) in table.columns"
                                            :key="`${ti}-${pi}-${ci}`"
                                        >
                                            {{ getAmountFormatted(table, item, col, pi) }}
                                        </td>

                                        <td
                                            class="text-right"
                                            v-if="table.relativePercentage"
                                            :key="`${ti}-${pi}-relativePercentage`"
                                        >
                                            {{ getRelativePercentage(item, pi) }}
                                        </td>
                                    </template>

                                    <td class="text-right" v-if="table.comparison?.difference">
                                        {{ formatDifference(item) }}
                                    </td>
                                    <td class="text-right" v-if="table.comparison?.percentage">
                                        {{ formatPercentage(item.percentage) }}
                                    </td>
                                </tr>
                            </template>
                        </oss-data-table>
                        <oss-data-table
                            :items="table.rows"
                            :headers="getHeaders(table)"
                            hide-default-footer
                            :items-per-page="-1"
                            class="table"
                            :x-dense="true"
                            fixed-header
                            item-key="key"
                            v-else
                        >
                            <template #item="{ item }">
                                <tr
                                    class="text-left"
                                    v-if="item.title && !item.total"
                                    :style="itemRowBackground(item)"
                                >
                                    <td
                                        colspan="1"
                                        class="vertical-sticky"
                                        :style="verticalSepratorStyle"
                                    >
                                        <strong>{{ item.title }}</strong>
                                    </td>
                                    <td :colspan="getColumnCount(table) - 1" />
                                </tr>
                                <tr
                                    :style="itemRowBackground(item)"
                                    @click.stop="item.isExpanded = !item.isExpanded"
                                    v-else-if="withAmountOrNotOptional(item)"
                                >
                                    <td
                                        class="text-left vertical-sticky"
                                        :style="colorElement2(item)"
                                    >
                                        {{ getRowTitle(item) }}
                                    </td>
                                    <template v-for="(period, pi) in resultPeriods">
                                        <td
                                            class="text-right"
                                            :style="
                                                addVerticalSeparatorStyle(table, ci, pi)
                                                    ? verticalSepratorStyle
                                                    : ''
                                            "
                                            v-for="(col, ci) in table.columns"
                                            :key="`${ti}-${pi}-${ci}`"
                                        >
                                            {{ getAmountFormatted(table, item, col, pi) }}
                                        </td>
                                        <td
                                            class="text-right"
                                            v-if="table.relativePercentage"
                                            :key="`${ti}-${pi}-relativePercentage`"
                                        >
                                            {{ getRelativePercentage(item, pi) }}
                                        </td>
                                    </template>
                                    <td class="text-right" v-if="table.comparison?.difference">
                                        {{ formatDifference(item) }}
                                    </td>
                                    <td class="text-right" v-if="table.comparison?.percentage">
                                        {{ formatPercentage(item.percentage) }}
                                    </td>
                                </tr>
                                <template v-if="item.isExpanded">
                                    <tr
                                        v-for="(subrow, subR) in item.subRows"
                                        :key="`${item.id}-${subR}`"
                                        class="elevation-1"
                                        style="border: 0"
                                    >
                                        <td
                                            class="text-left font-italic vertical-sticky"
                                            style="box-shadow: inset -1px 0px grey"
                                            @click.stop="openAABDetailDialog(subrow.name)"
                                        >
                                            &emsp; &emsp; &emsp;{{
                                                subrow.name + " - " + subrow.description
                                            }}
                                        </td>
                                        <template v-for="(period, pi) in resultPeriods">
                                            <td
                                                v-for="(col, ci) in table.columnsToDisplay[pi]"
                                                :key="`${item.id}-${pi}-${ci}-${subR}`"
                                                class="text-right font-italic"
                                                :style="
                                                    getCellStyle(
                                                        table,
                                                        item,
                                                        ci,
                                                        pi,
                                                        undefined,
                                                        subrow,
                                                    )
                                                "
                                            >
                                                {{
                                                    getAmountFormatted(
                                                        table,
                                                        item,
                                                        col,
                                                        pi,
                                                        undefined,
                                                        subrow,
                                                    )
                                                }}
                                            </td>
                                            <td
                                                class="text-right"
                                                v-if="table.relativePercentage"
                                                :key="`${item.id}-${pi}-relativePercentage-${subR}`"
                                            >
                                                {{ getRelativePercentage(subrow, pi) }}
                                            </td>
                                        </template>
                                        <td
                                            class="text-right"
                                            v-if="table.comparison?.difference"
                                        />
                                        <td
                                            class="text-right"
                                            v-if="table.comparison?.percentage"
                                        />
                                        <template v-if="table.extraColumns">
                                            <td
                                                class="text-right"
                                                v-for="column in table.extraColumns"
                                                :key="column.name"
                                            />
                                        </template>
                                    </tr>
                                </template>
                            </template>

                            <template> </template>
                        </oss-data-table>
                    </div>
                </v-col>
            </v-row>
            <oss-dialog v-model="AABDialog" v-if="AABDialog">
                <v-row>
                    <v-col>
                        <AccountableAccountBalanceDetail
                            :companyId="companyId"
                            :accountingPeriodId="accountingPeriodId"
                            :accountableAccountInfo="{ name: selectedAccountableAccountName }"
                            :startDate="date.start"
                            :endDate="date.end"
                            @refresh="refresh"
                        />
                    </v-col>
                </v-row>
            </oss-dialog>
        </template>
    </v-container>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import ossDataTable from "../ossComponents/ossDataTable2.vue";
import { AccountingSheet } from "./AccountingSheet";
import AccountableAccountBalanceDetail from "../AccountableAccountBalanceDetail.vue";

import { DashBoardTable } from "../../../../backend/src/common/dashboard/dashboardTable";
// Queries to get balances
import OPERATING_ACCOUNT from "../../graphql/dashboardAccounting/OperatingAccountFromPartition.gql";
// import { User } from "../../store/store"
import ExcelServices from "../../services/excelServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";

@Component({
    components: {
        ossDataTable,
        AccountableAccountBalanceDetail,
    },
})
export class OperatingAccountFromPartition extends AccountingSheet {
    @Prop({ default: [] }) partitionTags: any[];
    @Prop({ default: [] }) operatingAccountJsons: any;

    partitionTagId: string = "";

    root = {
        name: "Racine",
        tags: [],
        selected: [],
    };

    getQuery() {
        return OPERATING_ACCOUNT;
    }

    get resultKey() {
        return "operatingAccountFromPartition";
    }

    get title() {
        return "Tableau personnalisé";
    }

    operatingAccountId: string = "";

    get tableTypes() {
        const tableTypes = [
            {
                id: "",
                name: "Comptes comptables",
            },
        ];
        if (this.OA_FlashSituation) {
            tableTypes.push(this.OA_FlashSituation);
        }
        if (this.OA_SIG) {
            tableTypes.push(this.OA_SIG);
        }
        if (this.OA_IncomeStatement) {
            tableTypes.push(this.OA_IncomeStatement);
        }
        return tableTypes;
    }

    get OA_SIG() {
        if (this.operatingAccountJsons) {
            const result = this.operatingAccountJsons.filter((e) => e.type === "SIG");
            if (result && result.length) {
                return result[0];
            }
        }
        return null;
    }

    get OA_IncomeStatement() {
        if (this.operatingAccountJsons) {
            const result = this.operatingAccountJsons.filter((e) => e.type === "INCOME_STATEMENT");
            if (result && result.length) {
                return result[0];
            }
        }
        return null;
    }

    get OA_FlashSituation() {
        if (this.operatingAccountJsons) {
            const result = this.operatingAccountJsons.filter((e) => e.type === "FLASH_SITUATION");
            if (result && result.length) {
                return result[0];
            }
        }
        return null;
    }

    beforeMount() {
        if (this.partitionTags.length) {
            this.partitionTagId = this.partitionTags[0].id;
        }
    }

    @Apollo({
        query() {
            return this.getQuery();
        },
        variables() {
            return {
                companyId: this.companyId,
                operatingAccountId: this.operatingAccountId,
                periods: this.periods,
                partitionId: this.partitionTagId,
                startPaths: this.startPaths,
            };
        },
        fetchPolicy: "network-only",
        skip() {
            return !this.periods.length || !this.getQuery() || !this.partitionTagId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loading = loading;
            if (!loading && data) {
                if (data[this.resultKey]) {
                    const output = data[this.resultKey].output;
                    if (this.operatingAccountId) {
                        for (const table of output.tables) {
                            for (const r of table.rows) {
                                r.isExpanded = false;
                            }
                            this.setColumnsToDisplay(output, table, output.periods);
                        }
                    }
                    this.output = output;
                    this.tables = data[this.resultKey].output.tables;
                    this.resultPeriods = data[this.resultKey].output.periods;
                    this.computeTableHeaders();
                    this.dashboardTable = new DashBoardTable(this.resultPeriods, this.tables);
                    this.updateAmounts();
                    if (this.tables[0].name === "") {
                        this.tables[0].rows.sort((rowA, rowB) => {
                            if (rowA.aaName < rowB.aaName) return -1;
                            if (rowB.aaName > rowA.aaName) return 1;
                            return 0;
                        });
                    }
                }
            }
        },
    })
    output = {
        resultPeriods: [],
        tables: [],
    };

    refresh() {
        if (this.$apollo.queries && this.$apollo.queries.output) {
            this.$apollo.queries.generalLedger.refetch();
        }
    }

    get selectedPath() {
        const path = [this.root];
        let current = this.root;
        while (current.selected.length === 1 && current.selected[0].tags.length) {
            path.push(current.selected[0]);
            current = current.selected[0];
        }
        return path;
    }

    get startPaths() {
        let startPath = "";

        let current = this.root;
        while (current.selected.length === 1 && current.selected[0].tags.length) {
            if (startPath) {
                startPath += "/";
            }
            startPath += current.selected[0].name;
            current = current.selected[0];
        }
        const startPaths = [];
        if (current.selected.length) {
            for (const selectedTag of current.selected) {
                let startPath1 = "";
                if (startPath) {
                    startPath1 += startPath + "/";
                }
                startPath1 += selectedTag.name;
                startPaths.push(startPath1);
            }
        } else if (startPath) {
            // startPath += "/"
            startPaths.push(startPath);
        }

        return startPaths;
    }

    emitDataToParent() {
        this.$emit(
            "emittedDataFromOAFP",
            this.operatingAccountId,
            this.partitionTagId,
            this.selectedPath,
        );
    }

    @Watch("operatingAccountId")
    operatingAccountIdChanged() {
        this.emitDataToParent();
    }

    @Watch("partitionTagId")
    onPartitionTagIdchanged() {
        this.emitDataToParent();
        this.root = {
            name: "Racine",
            tags: [],
            selected: [],
        };
        const partition = this.partitionTags.find((p) => p.id === this.partitionTagId);
        if (partition) {
            for (const tag of partition.tags) {
                const subTagNames = tag.name.split("/");
                let current = this.root;
                for (const subTagName of subTagNames) {
                    const lcSubTagName = subTagName.toLowerCase();
                    let subTag = current.tags.find((t) => t.name.toLowerCase() === lcSubTagName);
                    if (subTag) {
                        current = subTag;
                    } else {
                        subTag = {
                            name: subTagName,
                            tags: [],
                            selected: [],
                        };
                        current.tags.push(subTag);
                    }
                    current = subTag;
                }
            }
        }
    }

    @Watch("selectedPath")
    selectedPathChanged() {
        this.emitDataToParent();
    }

    colorElement2(item) {
        let style = this.colorElement(item);
        style += "box-shadow: inset -1px 0px grey;";
        return style;
    }

    getHeaderStyle(ri, column, ci) {
        let style = column.width ? "width:" + column.width : "";
        if (ci === 0) {
            if (style) style += "; ";
            style += "box-shadow: inset -1px 0px grey;"; //  class="vertical-sticky" style="box-shadow: inset -1px 0px grey;">
        }
        return style;
    }

    getHeaderClass(ri, column, ci) {
        let cssClass = column.align ? "text-" + column.align : "";
        if (ci === 0) {
            if (cssClass) cssClass += " ";
            cssClass += "vertical-sticky";
        }
        return cssClass;
    }

    getRowTitle(row) {
        if (row.name) {
            if (row.aaName) {
                return row.aaName + " - " + row.name;
            }
            return row.name;
        }
        return row.title;
    }

    get allTags(): any[] {
        return this.partitionTags?.flatMap((partition) => partition.tags) || [];
    }

    download(table) {
        const excelServices = new ExcelServices();
        excelServices.exportAccountingTable(table, this.periods, this.allTags, this.companyName);
    }

    copy(table) {
        const excelServices = new ExcelServices();
        excelServices.copyToClipboardAccountingTable(
            table,
            this.periods,
            this.allTags,
            this.companyName,
        );
    }
}

export default toNative(OperatingAccountFromPartition);
</script>

<style>
.tableStyle thead {
    position: sticky;
    top: 0;
    z-index: 5;
}
</style>
